<template>
  <NavBar
    v-model="showMenu"
    :class="{ 'without-notch': !showNotchButton }"
    :menus="menus"
    :fixed-to-bottom="fixedToBottom"
    :default-actions="defaultActions"
  />
</template>
<script>
import schoolYearMixin from 'src/mixins/management/schoolYearMixin.js'
import NavBar from 'src/components/miscellaneous/ui/navs/NavBar.vue'
import clyTracking from 'src/config/services/countlyTracking/clyTracking.js'

export default {
  name: 'SduiNavBar',
  components: { NavBar },
  mixins: [schoolYearMixin],
  props: {
    fixedToBottom: { type: Boolean, default: true },
  },

  data: () => ({
    showMenu: false,
    classbook: null,
  }),

  computed: {
    footerMenuKeys() {
      const footer = this.$me && this.$me.school.meta.footer_menu
      if (footer && footer.length) {
        return footer
      }

      return ['feed', 'timetable', this.isLite ? 'cloud' : 'channels', 'more']
    },

    menuSettings() {
      return {
        feed: {
          key: 'feed',
          navigate: { name: 'feed' },
          icon: 'icon-news',
          title: this.$t('global.footer.news'),
        },

        timetable: {
          key: 'timetable',
          navigate: { name: 'timetable-middle' },
          icon: 'icon-timetable',
          title: this.$t('global.footer.timetable'),
        },

        settings: {
          key: 'account',
          navigate: { name: 'settings-overview-01' },
          icon: 'icon-settings',
          title: this.$t('global.options'),
        },

        channels: {
          key: 'channels',
          navigate: { name: 'channels' },
          icon: 'icon-chat',
          title: this.$t('global.footer.chats'),
        },

        cloud: {
          key: 'cloud',
          navigate: { name: 'cloud-group-view-lite' },
          icon: 'icon-cloud',
          title: this.$t('global.footer.cloud'),
        },

        more: {
          key: 'more',
          navigate: { name: 'more' },
          icon: 'icon-more',
          title: this.$t('global.footer.more'),
        },

        notch: {
          key: 'notch',
        },
      }
    },

    menus() {
      const menus = this.footerMenuKeys.map((key) => this.menuSettings[key])

      if (!this.showNotchButton) return menus
      const midIndex = Math.floor(menus.length / 2)

      return [...menus.slice(0, midIndex), this.menuSettings.notch, ...menus.slice(midIndex)]
    },

    defaultActions() {
      return [
        {
          title: this.$t('global.notch.create_file'),
          routeName: 'cloud-create-file',
          isActive: true,
          can: 'create-news',
          track: () => clyTracking.trackCloud().start.upload({ type: 'file' })
        },
        {
          title: this.$t('global.notch.create_event'),
          customEvent: {
            name: 'event-creation',
            fn: this.openEventCreation,
          },

          dataCy: 'create-event',
          isActive: true,
          preventFocusReturnOnModalClose: true,
          can: 'create-events',
          track: () => clyTracking.trackCalendar().start.create()
        },
        {
          title: this.$t('global.notch.create_news'),
          routeName: 'news-create',
          isActive: true,
          can: 'create-news',
          track: () => clyTracking.trackNews().start.create()
        },
        {
          title: this.$t('global.notch.create_sick_note'),
          routeName: 'sick-notes-overview',
          isActive: true,
          can: 'view-sick-notes',
          disabledWithLoadingSpinner: this.$store.getters['users/getLoadingSelf'],
          permObject: this.classbook,
          params: {
            classbook: String(this.classbook?.id),
            create: true,
          },

          track: () => clyTracking.trackClassbook('absence').start.create()
        }
      ]
    },

    meId() {
      return this.$me ? this.$me.id : 0
    },

    isLite() {
      return this.$me ? this.$me.school && Number(this.$me.school.properties.channels) : 0
    },

    showNotchButton() {
      return (
        this.$can('create-news', this.$me) ||
        (this.classbook && this.$can('view-sick-notes', this.classbook)) ||
        this.$can('create-events', this.$me)
      )
    },
  },

  methods: {
    openEventCreation() {
      this.showMenu = false

      // open modal by setting query param
      const openModalQuery = {
        params: this.$route.params,
        query: { ...this.$route.query, 'event-creation': 'true' },
      }
      this.$router.push(openModalQuery)
    },
  },

  watch: {
    '$me.school_id': {
      handler: async function (schoolId) {
        if (!schoolId) return
        this.classbook = this.$me.school.getCurrentActiveClassbook()
      },

      immediate: true,
    },
  },
}
</script>
